import { render, staticRenderFns } from "./AnswerInput.vue?vue&type=template&id=7dff2a0b&scoped=true&"
import script from "./AnswerInput.vue?vue&type=script&lang=ts&"
export * from "./AnswerInput.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerInput.vue?vue&type=style&index=0&id=7dff2a0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff2a0b",
  null
  
)

export default component.exports